// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__fgC2J","content":"LoadingAlert_content__2962q"};